export default __webpack_public_path__ + "static/media/resumeai.aff829e5.png";